import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useDomain } from '../context/DomainContext';
import LoadingSplash from './LoadingSplash';

const PublicRoute = ({ children }) => {
    const { user, profile, loading: authLoading } = useAuth();
    const { loading: domainLoading } = useDomain();

    // Mostra loading solo se stiamo effettivamente caricando qualcosa
    // Rimuoviamo isInitialized che non esiste nel nuovo AuthContext
    if (authLoading) {
        return <LoadingSplash />;
    }

    // Se l'utente è autenticato e ha un profilo, redirect alla dashboard appropriata
    if (user && profile) {
        console.log('PublicRoute: User authenticated, redirecting...');
        console.log('PublicRoute: Checking profile roles:', profile.roles);
        
        // Controllo ruoli admin
        const isAdmin = profile.roles && (
            profile.roles.includes('platform_admin') || 
            profile.roles.includes('project_admin') || 
            profile.roles.includes('brand_admin') || 
            profile.roles.includes('organization_admin')
        );

        if (isAdmin) {
            console.log('PublicRoute: Admin detected. Redirecting to /AdminDashboard.');
            return <Navigate to="/AdminDashboard" replace />;
        }
        
        console.log('PublicRoute: Standard user detected. Redirecting to /UserDashboard.');
        return <Navigate to="/UserDashboard" replace />;
    }

    // Utente non autenticato, mostra la pagina pubblica (login/register)
    return children;
};

export default PublicRoute;